<template>
  <div>
    <h1>Автентифікація...</h1>
  </div>
</template>

<script>

import store from '../store'
import router from '../router'

export default {
  async created () {
    const code = this.$route.query.code

    if (!code) {
      router.push({ name: 'error', params: { message: 'The authentication response did not contain a valid code' } })
      return
    }

    try {
      await store.dispatch('authorizationCodeGrant', { code: code })

      router.push({ name: 'home' })
    } catch (error) {
      if (error.name === 'NotAuthorizedException') {
        router.push({ name: 'error', params: { message: 'Ви не маєте необхідних дозволів. будь ласка, зверніться до адміністратора рідне слово.' } })
      } else {
        router.push({ name: 'error', params: { message: error.message } })
      }
      return
    }
  }
}

</script>


// WEBPACK FOOTER //
// Callback.vue?4a28d336